import React from 'react'
import { Wrap } from './style'

const Overlay = ({ style, onClick }) => {
  return <Wrap style={style} onClick={onClick}/>
}

export default Overlay
